const origin_countries_options = [
  { label: "PL — Polska", value: "PL" },
  { label: "CN — Chiny", value: "CN" },
  { label: "DE — Niemcy", value: "DE" },
  { label: "CZ — Czechy", value: "CZ" },
  { label: "SK — Słowacja", value: "SK" },
  { label: "IT — Włochy", value: "IT" },
  { label: "FR — Francja", value: "FR" },
  { label: "ES — Hiszpania", value: "ES" },
  { label: "NL — Holandia", value: "NL" },
  { label: "BE — Belgia", value: "BE" },
  { label: "AT — Austria", value: "AT" },
  { label: "BG — Bułgaria", value: "BG" },
  { label: "HR — Chorwacja", value: "HR" },
  { label: "CY — Cypr", value: "CY" },
  { label: "DK — Dania", value: "DK" },
  { label: "EE — Estonia", value: "EE" },
  { label: "FI — Finlandia", value: "FI" },
  { label: "GR — Grecja", value: "GR" },
  { label: "HU — Węgry", value: "HU" },
  { label: "IE — Irlandia", value: "IE" },
  { label: "LT — Litwa", value: "LT" },
  { label: "LU — Luksemburg", value: "LU" },
  { label: "LV — Łotwa", value: "LV" },
  { label: "MT — Malta", value: "MT" },
  { label: "PT — Portugalia", value: "PT" },
  { label: "RO — Rumunia", value: "RO" },
  { label: "SE — Szwecja", value: "SE" },
  { label: "SI — Słowenia", value: "SI" },
  { label: "GB — Wielka Brytania", value: "GB" },
  { label: "CH — Szwajcaria", value: "CH" },
  { label: "NO — Norwegia", value: "NO" },
  { label: "UA — Ukraina", value: "UA" },
  { label: "TR — Turcja", value: "TR" },
  { label: "US — Stany Zjednoczone", value: "US" },
  { label: "IN — Indie", value: "IN" },
  { label: "VN — Wietnam", value: "VN" },
  { label: "TW — Tajwan", value: "TW" },
  { label: "KR — Korea Południowa", value: "KR" },
  { label: "JP — Japonia", value: "JP" },
  { label: "TH — Tajlandia", value: "TH" },
  { label: "MY — Malezja", value: "MY" },
  { label: "ID — Indonezja", value: "ID" },
  { label: "PK — Pakistan", value: "PK" },
  { label: "BD — Bangladesz", value: "BD" },
  { label: "MX — Meksyk", value: "MX" },
  { label: "BR — Brazylia", value: "BR" },
  { label: "CA — Kanada", value: "CA" },
  { label: "RS — Serbia", value: "RS" },
  { label: "BA — Bośnia i Hercegowina", value: "BA" },
  { label: "MK — Macedonia Północna", value: "MK" },
  { label: "IL — Izrael", value: "IL" },
  { label: "AE — Zjedn. Emiraty Arabskie", value: "AE" },
  { label: "EG — Egipt", value: "EG" },
  { label: "MA — Maroko", value: "MA" },
  { label: "TN — Tunezja", value: "TN" },
  { label: "ZA — RPA", value: "ZA" },
  { label: "AU — Australia", value: "AU" },
  { label: "NZ — Nowa Zelandia", value: "NZ" },
  { label: "HK — Hongkong", value: "HK" },
  { label: "SG — Singapur", value: "SG" },
  { label: "PH — Filipiny", value: "PH" },
  { label: "LK — Sri Lanka", value: "LK" },
  { label: "KH — Kambodża", value: "KH" },
  { label: "MD — Mołdawia", value: "MD" },
  { label: "GE — Gruzja", value: "GE" },
  { label: "AM — Armenia", value: "AM" },
  { label: "AZ — Azerbejdżan", value: "AZ" },
  { label: "KZ — Kazachstan", value: "KZ" },
  { label: "UZ — Uzbekistan", value: "UZ" },
  { label: "AR — Argentyna", value: "AR" },
  { label: "CL — Chile", value: "CL" },
  { label: "CO — Kolumbia", value: "CO" },
  { label: "PE — Peru", value: "PE" },
  { label: "IS — Islandia", value: "IS" },
  { label: "LI — Liechtenstein", value: "LI" },
  { label: "AL — Albania", value: "AL" },
  { label: "ME — Czarnogóra", value: "ME" },
  { label: "XK — Kosowo", value: "XK" },
];

export default origin_countries_options;
